import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import Btn from "../../../../components/atoms/Btn";
import Settings from "../Settings";
import Stage from "../../models/Stage";
import ZoomService from "../../services/zoomService";
import Aside from "../Aside/Aside";
import PositionList from "../Header/PositionList";
import TimesIcon from "../../../../components/icons/Times";

function Sidebar({
  stage,
  zoomService,
  setOptions,
  reset,
  InfoRenderer,
  ...props
}) {
  const info = "info";
  const settings = "settings";
  const bookmarks = "bookmarks";
  const [openTab, setOpenTab] = useState(null);
  const [isInfoOpen, setIsInfoOpen] = useState(true);
  const handleTab = useCallback((tab) => setOpenTab(tab), [openTab]);
  const buttons = [
    {
      icon: "fa fa-bookmark",
      title: "Saved",
      key: bookmarks,
      callback: () => handleTab(bookmarks),
    },
    {
      icon: "fa fa-cogs",
      title: "Settings",
      key: settings,
      callback: () => handleTab(settings),
    },

    InfoRenderer
      ? {
          key: "seperator",
          icon: null,
          title: null,
          className: "tw-border-b border-1 tw-m-2 tw-mt-6 tw-w-6",
        }
      : null,

    InfoRenderer
      ? {
          icon: "fa fa-info-circle",
          key: info,
          title: "Samples",
          callback: () => setIsInfoOpen(!isInfoOpen),
        }
      : null,
    {
      key: "spacer",
      icon: null,
      title: null,
      className: "tw-flex-grow",
    },
    {
      key: "reset",
      icon: "fa fa-undo",
      title: "Reset",
      callback: () => reset(),
    },
  ].filter(Boolean);

  return (
    <div className="tw-relative tw-flex">
      {InfoRenderer && isInfoOpen ? (
        <div className="tw-border-l border-1 tw-overflow-auto shadow-inner-xl tw-relative">
          <div className="tw-absolute tw-top-0 tw-right-0 tw-p-1 tw-m-1">
            <Btn onSubmit={() => setIsInfoOpen(false)}>
              <TimesIcon
                className="hover:tw-text-black tw-cursor-pointer tw-fill-current tw-text-coolGray-600"
                size={16}
              />
            </Btn>
          </div>

          <InfoRenderer zoomService={zoomService} stage={stage} />
        </div>
      ) : null}
      <div className="tw-w-16 tw-border-l border-1 tw-flex tw-flex-col tw-items-center tw-text-2xs tw-py-2">
        {buttons.map((x) => {
          return x.icon ? (
            <Btn
              className={`color-3 tw-opacity-80 hover:tw-opacity-100 tw-px-2 tw-py-1 tw-rounded `}
              onSubmit={x.callback}
              key={x.title}
            >
              <div className="tw-flex tw-flex-col tw-h-14 tw-mt-2">
                <div
                  className={`tw-rounded-lg ${
                    x.key === info && isInfoOpen ? "tw-text-sky-500" : ""
                  }`}
                >
                  <i className={`${x.icon} tw-text-lg`} />
                  <br />
                  <span className="t">{x.title}</span>
                </div>
              </div>
            </Btn>
          ) : (
            <div key={x.key} className={x.className} />
          );
        })}
      </div>

      <Aside
        forceClose={() => handleTab(null)}
        isOpen={openTab === settings}
        className="tw-absolute bg-1 color-1 tw-right-0 tw-inset-y-0 tw-overflow-auto tw-transition-all tw-duration-300 shadow-2xl"
      >
        <Settings
          {...props}
          stage={stage}
          zoomService={zoomService}
          setOptions={setOptions}
          reset={() => stage.resetRenderer()}
        />
      </Aside>

      <Aside
        forceClose={() => handleTab(null)}
        isOpen={openTab === bookmarks}
        className="tw-absolute bg-1 color-1 tw-right-0 tw-inset-y-0 tw-overflow-auto tw-transition-all tw-duration-300 shadow-2xl"
      >
        <PositionList zoomService={zoomService} />
      </Aside>
    </div>
  );
}

Sidebar.propTypes = {
  zoomService: PropTypes.instanceOf(ZoomService).isRequired,
  stage: PropTypes.instanceOf(Stage).isRequired,
  setOptions: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  InfoRenderer: PropTypes.func,
};

Sidebar.defaultProps = {
  InfoRenderer: null,
};

export default React.memo(Sidebar);
